export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjAzNDkzMWU0LTQ1MzQtNGYxYy1iNmEwLWY2OWU1MGNiNGU1OCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.Nvq4xwtbOeJUPXsiJxlB/sGld9i0zi34afnEteHzVpz6E9lE3Z57fgnYuWWuaMoFiHQfFWpNXec987NUqy4iXCNOgDdQ8fD3bkI0/9FS7eK3EbVrmu7xvOW+CD2Dru5CcJc0+A==';
